module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_d/logo-aoj-zh-hant-c22ce5c3f949edf6e8f87d31ee220b44.svg";